<template>
  <div class="home">
    <h1>This is an home page</h1>
  </div>
</template>

<script>

export default {
  name: "home"
};
</script>
